import React, {Fragment, useState, useEffect} from 'react'
import {Accordion, Form, Icon, Menu} from 'semantic-ui-react'
import {useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as StoriesActions from '../../../actions/StoriesActions'

const platforms = {
    'ios': {
        name: 'iOS'
    },
    'android': {
        name: 'Android'
    }
};

export const Channels = (props) => {
    const [active, setActive] = useState(false);
    const dispatch = useDispatch();
    useFirestoreConnect([
        { collection: 'environments/' + env + '/lotteries' }
    ])

    const selectedLotteries = useSelector(({stories}) => (typeof stories.selected.settings.lotteries === 'undefined')?null:stories.selected.settings.lotteries);
    const selectedplatforms = useSelector(({stories}) => (typeof stories.selected.settings.platforms === 'undefined')?null:stories.selected.settings.platforms);
    const lotteries = useSelector(({ firestore: { data } }) => data['environments/' + env + '/lotteries'])

    useEffect(() => {
        if(typeof lotteries !== 'undefined' && lotteries !== null && selectedLotteries === null){
            let initialLotteries = {};
            Object.keys(lotteries).forEach((lotteryId) => initialLotteries[lotteryId] = true);

            dispatch(StoriesActions.update_settings('lotteries', initialLotteries))
        }
    }, [lotteries, selectedLotteries]);

    useEffect(() => {
        if(selectedplatforms === null){
            let initialplatforms = {};
            Object.keys(platforms).forEach((platformId) => initialplatforms[platformId] = true);

            dispatch(StoriesActions.update_settings('platforms', initialplatforms))
        }
    }, [lotteries, selectedLotteries]);

    return (
        <Fragment>
            <Accordion.Title active={active} onClick={(e) => {
                setActive(!active);
            }}><Icon name='dropdown' /> Ausgabekanäle</Accordion.Title>
            <Accordion.Content active={active}>
                <Form>
                    <label style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>Bundesländer</label>
                    <Menu vertical fluid>
                    {
                        (typeof lotteries !== 'undefined' && lotteries !== null && selectedLotteries !== null)?
                            Object.keys(lotteries).map((lotteryId) => {
                                let lottery = lotteries[lotteryId];

                                return (
                                    <Menu.Item disabled={props.readonly?true:null}  icon={selectedLotteries[lotteryId]?"check":null} content={lottery.state} active={!selectedLotteries[lotteryId]} onClick={(e) => {
                                        dispatch(StoriesActions.update_settings('lotteries', {...selectedLotteries, [lotteryId]: !selectedLotteries[lotteryId]}))
                                    }}></Menu.Item>
                                )
                            })
                        :null
                    }
                    </Menu>
                    <label style={{
                        display: 'block',
                        fontWeight: 'bold',
                        marginBottom: '0.3em',
                        fontSize: '.92857143em'
                    }}>Geräte</label>
                    <Menu vertical fluid>
                    {
                        (selectedplatforms !== null)?
                            Object.keys(platforms).map((platformId) => {
                                const platform = platforms[platformId];

                                return (
                                    <Menu.Item disabled={props.readonly?true:null} color={'green'} icon={selectedplatforms[platformId]?"check":null} content={platform.name} active={!selectedplatforms[platformId]} onClick={(e) => {
                                        dispatch(StoriesActions.update_settings('platforms', {...selectedplatforms, [platformId]: !selectedplatforms[platformId]}))
                                    }}></Menu.Item>
                                )
                            })
                        :null
                    }
                    </Menu>
                </Form>
            </Accordion.Content>
        </Fragment>
    )
}